import * as React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import {QRCodeSVG} from 'qrcode.react';

const API = require("../../data/network/API");

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function Roulette() {
  const {state} = useLocation();
  const navigate = useNavigate();
  const [roulette, setRoulette] = React.useState(state);
  const [open, setOpen] = React.useState(false);
  const [complete, setComplete] = React.useState(false);
  const [degrees, setDegrees] = React.useState(Math.ceil(Math.random()*3600));

  const [reward, setReward] = React.useState(null);
  const [position, setPosition] = React.useState(null);

  const [result, setResult] = React.useState(null);

  const handleClickOpen = () => {
      //setOpen(true);
  }
  
  const handleClose = () => {
      //setOpen(false);
      //navigate('/main/home');
  }

  const spinRoulette=()=>{
    const newDegrees=degrees+Math.ceil(Math.random()*3600)
    setDegrees(newDegrees)
    //console.log("grados totales:"+newDegrees)
    const times = Math.floor(newDegrees/360)
    //console.log("giros:"+times)
    const realDegrees = times*360
    //console.log("grados reales: "+realDegrees)
    const gradosAgregados = newDegrees - realDegrees
    //console.log("grados agregados: "+gradosAgregados)
    const index = Math.floor(gradosAgregados/22.5)
    //console.log("position:"+ position)
    const pos = getMirroDegree(index)
    setPosition(pos)
  }

  function getMirroDegree(position){
    switch(position){
      case 1:
         return 15
      case 2:
        return 14
      case 3:
        return 13
      case 4:
        return 12
      case 5:
        return 11
      case 6:
        return 10
      case 7:
        return 9
      case 8:
        return 8
      case 9:
        return 7
      case 10:
        return 6
      case 11:
        return 5
      case 12:
        return 4
      case 13:
        return 3
      case 14:
        return 2
      case 15:
        return 1
        
      default:
        return 0
    }
  }

  async function postRoulette(premio_ganado){

    const signin_data = localStorage.getItem("signin-data");
    const data = JSON.parse(signin_data);
    const requestBody = {
        id_usuario: data.usuario.firestore_id ,
        id_campaña: roulette.id_campaña,
        id_ruleta: roulette.firestore_id,
        nombre: roulette.nombre,
        descripcion: roulette.descripcion,
        premio_ganado: premio_ganado,
        premios: roulette.premios
    }

    const response = await API.postRoulette(requestBody)
    console.log(response)
    if(response.status == 200){
      setResult(response.data)
    }else{

    }
  }

  const handleTransitionEnd = () => {
    
    setReward(roulette.premios[position]) 

    postRoulette(roulette.premios[position])
  };
  
  return (
      <Box sx={{ 
          flexGrow: 1, 
       
          backgroundImage: `radial-gradient(circle at top left, rgba(60, 60, 60, 0.39) 0%, rgba(10, 10, 10, 0.86) 100%), url(${roulette.imagen_fondo_url}) !important`,
          backgroundRepeat: `no-repeat`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: "100vh",
          width: "100%",
        }}>  
         <div sx={{ my: 1, mx: 'auto'}}>
          <Stack spacing={1} sx={{pt:8, mb:2, alignItems:'center'}}> 
                <Box
                  alignSelf= 'center'
                  component="img"
                  sx={{
                    height: 124,
                    width: 195,
                  }}
                  alt="officia logo."
                  src={roulette.imagen_titulo_url}
                />
                <Box 
                  component="img"
                  sx={{ 
                      height: 64,
                      width: 64,
                      maxHeight: { xs: 64, md: 64 },
                      maxWidth: { xs: 64, md: 64 },
                      overflow:1,
                     
                    }}
                    alt="Participa y gana."
                    src="/static/ruleta_pin.png"
                  />  
                <Box 
                  component="img"
                  sx={{ 
                      height: 300,
                      width: 300,
                      maxHeight: { xs: 300, md: 300 },
                      maxWidth: { xs: 300, md: 300 },
                      overflow:1,
                      transition: "transform 5s ease-in-out",
                      transform: `rotate(${degrees}deg)`
                    }}
                    onTransitionEnd={handleTransitionEnd}
                    alt="Participa y gana."
                    src={roulette.imagen_ruleta_url}
                  />  
               {!result ? 
                <>
                <Typography variant="caption" gutterBottom sx = {{textAlign:'center'}}>
                    ¡Haz girar la ruleta!
                </Typography>
                <Button disabled={reward!=null} variant='contained' color='secondary' onClick={spinRoulette}>
                    Jugar
                </Button>
                </>
                :
                <>
                <Stack spacing={2} alignItems="center">
                <Typography variant="h3" fontWeight="bolder" gutterBottom sx = {{textAlign:'center'}}>
                    {reward.nombre}
                </Typography>
                <QRCodeSVG value={result.firestore_id} />
                <Button  variant='contained' color='secondary'>
                    Continuar
                </Button>
                </Stack>
                </>
               }   
            </Stack>
          </div>  
          <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
              <DialogTitle>{"¡Tus respuestas han sido enviadas!"}</DialogTitle>
          </Dialog>
      </Box>
  )
}